// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import Address from "./types/address";

/**
 * Asks the backend to rebuild ONE past session identity — the L2 address this
 * browser remembers for the session that opened a now-stranded channel — from
 * its cached key, for this connection only, so the channel can be surfaced
 * and force-closed by the user. Mirrors FinishSwap, minus the signed state:
 * the address is enough, the backend still holds the channel record.
 */
@jsonObject
export default class RecoverInitialize extends PerunMessage {
  @jsonMember(String) clientPubKey: string;
  @jsonMember(Address) ethClientAddress: Address;
  @jsonMember(String) steClientAddress: string;
  @jsonMember(String) codeHash: string;
  @jsonMember(String) l2Address: string;

  constructor(clientPubKey: string, ethClientAddress: Address, steClientAddress: string, codeHash: string, l2Address: string) {
    super();
    this.clientPubKey = clientPubKey;
    this.ethClientAddress = ethClientAddress;
    this.steClientAddress = steClientAddress;
    this.codeHash = codeHash;
    this.l2Address = l2Address;
  }

  messageType(): MessageType {
    return RecoverInitialize;
  }

  messageTypeName(): MessageTypeName {
    return "RecoverInitialize";
  }
}
